import type { InvalidationController } from "$lib/controller/invalidation"
import { uniqueContext } from "@tastyworks/ui-library"
import type { NavController } from "./controller/navigation.svelte"

type GroupContext = {
  disclaimer?: string
}
const groupContext = uniqueContext<GroupContext>()
export const getGroupContext = groupContext.getContext
export const setGroupContext = groupContext.setContext

const navContext = uniqueContext<NavController>()
export const getNavContext = navContext.getContext
export const setNavContext = navContext.setContext

type MobileMenuContext = {
  isOpen: boolean
  close: () => void
  toggle: () => void
}

const mobileMenuContext = uniqueContext<MobileMenuContext>()
export const setMobileMenuContext = mobileMenuContext.setContext
export const getMobileMenuContext = mobileMenuContext.getContext

const invalidationContext =
  uniqueContext<InvalidationController>("invalidation")
export const getInvalidationContext = invalidationContext.getContext
export const setInvalidationContext = invalidationContext.setContext

type StepChartContext = {
  getNextNumber: () => number
}
const stepChartContext = uniqueContext<StepChartContext>()
export const getStepChartContext = stepChartContext.getContext
export const setStepChartContext = stepChartContext.setContext
